import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SportEventOffersV2_MultiStepSportEvent_Fragment = {
	__typename?: 'MultiStepSportEvent';
	offerCount: number;
	watchNowOffer?: {
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
			iconWide: string;
		};
	} | null;
	offers: Array<{
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
};

export type SportEventOffersV2_SingleStepSportEvent_Fragment = {
	__typename?: 'SingleStepSportEvent';
	offerCount: number;
	watchNowOffer?: {
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
			iconWide: string;
		};
	} | null;
	offers: Array<{
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
};

export type SportEventOffersV2Fragment =
	| SportEventOffersV2_MultiStepSportEvent_Fragment
	| SportEventOffersV2_SingleStepSportEvent_Fragment;

export type SportEventOfferFragment = {
	__typename?: 'SportOffer';
	monetizationType: Types.MonetizationType;
	presentationType: Types.PresentationType;
	audioLanguage?: string | null;
	standardWebURL?: string | null;
	sportObjectType: Types.SportObjectType;
	package: {
		__typename?: 'Package';
		id: string;
		packageId: number;
		technicalName: string;
		clearName: string;
		shortName: string;
		monetizationTypes: Array<Types.MonetizationType>;
	};
};

export const SportEventOfferFragmentDoc = gql`
	fragment SportEventOffer on SportOffer {
		package {
			id
			packageId
			technicalName
			clearName
			shortName
			monetizationTypes
		}
		monetizationType
		presentationType
		audioLanguage
		standardWebURL
		sportObjectType
	}
`;
export const SportEventOffersV2FragmentDoc = gql`
	fragment SportEventOffersV2 on SportEventV2 {
		offerCount(country: $country, platform: $platform, filter: { bestOnly: false })
		watchNowOffer(country: $country, platform: $platform) {
			package {
				id
				packageId
				technicalName
				clearName
				shortName
				monetizationTypes
				iconWide
			}
			monetizationType
			presentationType
			audioLanguage
			standardWebURL
			sportObjectType
		}
		offers(country: $country, platform: $platform, filter: { bestOnly: false }) {
			...SportEventOffer
		}
	}
	${SportEventOfferFragmentDoc}
`;
